"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
const en = require('../languages/en');
const it = require('../languages/it');
const es = require('../languages/es');
const fr = require('../languages/fr');
exports.updateLanguage = (language) => {
    return {
        type: 'UPDATE_LANGUAGE',
        language,
    };
};
// , it, es, fr
exports.languages = {
    en,
};
exports.intl = (state = en, action) => {
    switch (action.type) {
        case 'UPDATE_LANGUAGE':
            if (action.language === undefined) {
                return state;
            }
            return en;
        default:
            return state;
    }
};
